module.exports = __webpack_public_path__ + "static/media/guide-tour-step-5.dcec286f.gif";